<template>
  <div>
    <div v-if="this.newParticipation" class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Participations et résultat</h3>
            <button type="button"
                    class="btn btn-xs btn-default btn-flat margin pull-right"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="resetParticipationForm()"
            >
              Réinitialiser le formulaire
            </button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group"
                     :class="{'has-error': errors.has('newParticipation[membre]') }">
                  <label for="searchmember">Compétiteur</label>
                  <v-select v-model="newParticipation.membre"
                            label="fullName"
                            :filterable="false"
                            :taggable="false"
                            :debounce="250"
                            :on-search="SearchMembersResponse"
                            :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link
                                                  :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                {{ props.selectedOption.fullName }}  - {{ props.selectedOption.age }}
                                                </router-link>
                                            </span>
                    <template slot="option" slot-scope="props">
                                            <span :class="props.item.licencie ? 'text-green' : 'text-red'">
                                                {{ props.item.fullName }} - {{ props.item.club.club }}
                                            </span>
                    </template>
                  </v-select>
                </div>

                <div class="form-group">
                  <label for="statut">Sexe</label>
                  <select id="statut" :disabled="!newParticipation.membre" class="form-control"
                          name="newParticipation[sexe]" v-model="sexeSelected">
                    <option :value="1"> Masculin</option>
                    <option :value="0"> Féminin</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="categage">Catégorie d'âge</label>
                  <select :disabled="!newParticipation.membre" id="categage" class="form-control"
                          name="newParticipation[categ_age]" v-model="newParticipation.id_age">
                    <option v-for="categ_age in filterCategAgeForThisCompetition()"
                            :value="categ_age.id">
                      {{ categ_age.categ_age }} ({{ categ_age.age_min }} - {{ categ_age.age_max }} ans)
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="categpoids">Catégorie de poids</label>
                  <select id="categpoids"
                          :disabled="!newParticipation.membre || !newParticipation.id_age"
                          class="form-control" name="newParticipation[categ_poids]" v-model="newParticipation.id_poids">
                    <option value="-1"></option>
                    <option v-if="newParticipation.membre"
                            v-for="categ_poids in filterCategPoidsForThisCompetition(newParticipation.id_age,sexeSelected)"
                            :value="categ_poids.id">
                      {{ categ_poids.poids }}
                    </option>
                  </select>
                </div>

                <div class="form-group"
                     :class="{'has-warning': dejaParticipeAB && newParticipation.id_grade==3 }">
                  <label for="categgrade">Catégorie de grade</label>
                  <select :disabled="!newParticipation.membre" id="categgrade" class="form-control"
                          name="newParticipation[categ_grade]" v-model="newParticipation.id_grade">
                    <option value="-1"></option>
                    <option v-for="cat_grade in getCategGrade"
                            :value="cat_grade.id"
                    >
                      {{ cat_grade.categ_grade }}
                    </option>
                  </select>
                  <span v-if="dejaParticipeAB && newParticipation.id_grade==3" class="help-block">
                                        Attention! Ce membre a déjà combattu en catégorie A/B
                                    </span>
                </div>

                <div class="form-group">
                  <div class="checkbox">
                    <label for="teamABFT">
                      <input id="teamABFT" name="newParticipation[teamABFT]" type="checkbox"
                             v-model="newParticipation.teamABFT">
                      A participé sous la team ABFT ?
                    </label>
                  </div>
                </div>

              </div>

              <div class="col-md-6 col-md-push-2">
                <div class="form-group">
                  <label style="float:left;display: block;clear: both;" for="combatseff">Combats effectués</label>
                  <div style="float:left;margin-left:30px;display: block;clear: both;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="combatseff"
                           v-for="combatseff in [0,1,2,3,4]">
                        <label>
                          <input type="radio" name="newParticipation[combat_eff]" :id="combatseff" :value="combatseff"
                                 v-model="newParticipation.combat_eff">
                          {{ combatseff == -1 ? 'N/C' : combatseff }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div style="float:left;margin-left:30px;display: block;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="combatseff"
                           v-for="combatseff in [5,6,7,8,9,-1]">
                        <label>
                          <input type="radio" name="newParticipation[combat_eff]" :id="combatseff" :value="combatseff"
                                 v-model="newParticipation.combat_eff">
                          {{ combatseff == -1 ? 'N/C' : combatseff }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label style="float:left;display: block;clear: both;" for="place">Place</label>
                  <div style="float:left;margin-left:30px;display: block;clear: both;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="place"
                           v-for="place in [1,2,3]">
                        <label>
                          <input v-html="get_place(place)"
                                 type="radio" name="newParticipation[place]" :id="place" :value="place"
                                 v-model="newParticipation.place">
                          <span v-html="get_place(place)"></span>
                        </label>
                      </div>
                    </div>

                    <div class="form-group" v-if="newParticipation.place==3">
                      <div class="checkbox">
                        <label for="petite_finale">
                          <input id="petite_finale" name="newParticipation[petite_finale]" type="checkbox"
                                 v-model="newParticipation.petite_finale">
                          Petite finale ?
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="radio"
                           :for="place"
                           v-for="place in [4]">
                        <label>
                          <input v-html="get_place(place)"
                                 type="radio" name="newParticipation[place]" :id="place" :value="place"
                                 v-model="newParticipation.place">
                          <span v-html="get_place(place)"></span>
                        </label>
                      </div>
                    </div>

                  </div>


                  <div style="float:left;margin-left:30px;display: block;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="place"
                           v-for="place in [5,9,17,33,65]">
                        <label>
                          <input v-html="get_place(place)"
                                 type="radio" name="newParticipation[place]" :id="place" :value="place"
                                 v-model="newParticipation.place">
                          <span v-html="get_place(place)"></span>
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="checkbox">
                        <label for="otherPlaceSelected">
                          <input id="otherPlaceSelected" name="newParticipation[otherPlaceSelected]" type="checkbox"
                                 v-model="otherPlaceSelected">
                          Autre place ?
                          <br/>
                          <input v-if="otherPlaceSelected" type="text" v-model="newParticipation.place" value=""/>
                        </label>
                      </div>
                    </div>

                  </div>


                </div>

              </div>
            </div>
          </div>
          <div class="overlay" v-if="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          <div class="box-footer">
            <input type="submit"
                   @click.prevent="addParticipation()"
                   :disabled="!isFormValid()"
                   value="Ajouter"
                   class="btn btn-primary pull-right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <b-col md="9" class="my-1">
              <h3 class="box-title">Listing des participations: {{ getCompetition.participations.length }}
                résultat{{ getCompetition.participations.length > 1 ? 's' : '' }}</h3>
            </b-col>
            <b-col md="3" class="my-1">
              <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
            </b-col>
          </div>
          <div class="box-body">
            <b-table
              id="tableListingAllCompetitions"
              v-if="getCompetition!=null"
              responsive bordered striped hover
              :items="getCompetition.participations"
              :fields="columnsListingParticipations"
              :current-page="pagination_meta.current_page"
              :per-page="pagination_meta.per_page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :no-local-sorting="false"
              :no-sort-reset="true"
              :empty-text="'Aucun résultat'"
              :empty-filtered-text="'Aucun résultat'"
              :filter="filter"
              :busy.sync="loading"
              :sort-compare="sortCompareAdvanced"
              foot-clone
              show-empty
            >
              <template slot="actions" slot-scope="data">
                <button v-if="!isEditing(data.item.id)"
                        @click.prevent="editItem(data.item)"
                        class="btn btn-default padding2">
                  <i class="glyphicon glyphicon-pencil"></i>
                </button>
                <button v-if="!isEditing(data.item.id)"
                        @click.prevent="removeParticipations(data.item.id)"
                        class="btn btn-default padding2">
                  <i class="glyphicon glyphicon-remove"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="validEditing(data.item.id)"
                        class="btn btn-primary padding2">
                  <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="cancelEditing(data.item.id)"
                        class="btn btn-danger padding2">
                  <i class="glyphicon glyphicon-ban-circle"></i>
                </button>
              </template>

              <template slot="membre.nom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{ data.item.membre.nom }}
                </router-link>
              </template>

              <template slot="membre.prenom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{ data.item.membre.prenom }}
                </router-link>
              </template>

              <template slot="cat_sexe" slot-scope="data">
                {{ findCategPoids(data.item.id_poids).sexe == 1 ? 'Masculin' : 'Féminin' }}
              </template>

              <template slot="cat_age" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ findCategAge(data.item.id_age).categ_age }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_age">
                    <option v-for="categ_age in filterCategAgeForThisCompetition(getCategAge)"
                            :value="categ_age.id"
                    >
                      {{ categ_age.categ_age }}
                    </option>
                  </select>
                </div>
              </template>

              <template slot="id_club" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  <span v-if="findClubById(data.item.id_club)">{{ findClubById(data.item.id_club).nameFormat }}</span>
                  <span v-if="!findClubById(data.item.id_club)" class="text-red">AUCUN</span>
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_club">
                    <option value="0">AUCUN</option>
                    <option v-for="club in getListeClub"
                            :value="club.id"
                    >
                      {{ club.nameFormat }}
                    </option>
                  </select>
                </div>
              </template>

              <template slot="cat_poids" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ findCategPoids(data.item.id_poids).poids }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_poids">
                    <option
                      v-for="cat_poids in filterCategPoidsForThisCompetition(getObjectEditable(data.item.id).id_age, findCategPoids(getObjectEditable(data.item.id).id_poids).sexe)"
                      :value="cat_poids.id"
                    >
                      {{ cat_poids.poids }}
                    </option>
                  </select>
                </div>
              </template>

              <template slot="cat_grade" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ findCategGrade(data.item.id_grade).categ_grade }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_grade">
                    <option v-for="cat_grade in getCategGrade"
                            :value="cat_grade.id"
                    >
                      {{ cat_grade.categ_grade }}
                    </option>
                  </select>
                </div>
              </template>

              <template slot="place" slot-scope="data">
                <div v-if="!isEditing(data.item.id)"
                     v-html="get_place(data.item.place,data.item.petite_finale)"></div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).place">
                    <option v-for="place in [1,2,3,4,5,9,17,33,65]"
                            :value="place"
                            v-html="get_place(place)"
                    ></option>
                  </select>
                </div>
              </template>


              <template slot="petite_finale" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value ? "OUI" : "NON" }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <div v-if="getObjectEditable(data.item.id).place!=3">
                    {{ data.value ? "OUI" : "NON" }}
                  </div>
                  <select v-if="getObjectEditable(data.item.id).place==3"
                          v-model="getObjectEditable(data.item.id).petite_finale">
                    <option value="1">OUI</option>
                    <option value="0">NON</option>
                  </select>
                </div>
              </template>

              <template slot="teamABFT" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value ? "OUI" : "NON" }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).teamABFT">
                    <option value="1">OUI</option>
                    <option value="0">NON</option>
                  </select>
                </div>
              </template>

              <template slot="afficherAuRanking" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value ? "OUI" : "NON" }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).afficherAuRanking">
                    <option value="1">OUI</option>
                    <option value="0">NON</option>
                  </select>
                </div>
              </template>

              <template slot="combat_eff" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).combat_eff">
                    <option v-for="combat in [0,1,2,3,4,5,6,7,8,9,-1]"
                            :value="combat"
                            v-html="combat==-1 ? 'N/C' : combat"
                    ></option>
                  </select>
                </div>
              </template>

            </b-table>
            <b-pagination size="md"
                          :total-rows="getCompetition.participations.length"
                          v-model="pagination_meta.current_page"
                          :per-page="pagination_meta.per_page">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'
import ListSelectClub from '../../Communs/listeSelectClub'

require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

var _ = require('underscore')
var moment = require('moment')

export default {
  props: {},
  data() {
    return {
      arrayEdits: [],
      arrayParticipationsEdits: [],
      arrayOriginal: [],
      sortBy: "membre.nom",
      sortDesc: null,
      filter: null,
      dejaParticipeAB: false,
      participations: null,
      listingCompetitions: [],
      loadingListingCompetition: true,
      loading: false,
      isBusy: false,
      disabledBtn: false,
      current_page: 1,
      periodeDu: null,
      periodeAu: null,
      typeSelectedForFilter: 0,
      reset: false,
      otherPlaceSelected: false,
      sexeSelected: 1,
      newParticipation: null,
      previousParticipation: null,
      previousRequest: false,
      ArrayMembersSearch: [],
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 20,
        to: 1,
        total: 1
      },
      columnsListingParticipations: [
        {
          label: 'Nom',
          key: 'membre.nom',
          sortable: true,
        },
        {
          label: 'Prénom',
          key: 'membre.prenom',
          sortable: true,
        },
        {
          label: 'A participé pour le club',
          key: 'id_club',
          sortable: true,
        },
        {
          label: 'Cat. Sexe',
          key: 'cat_sexe',
          sortable: false,
        },
        {
          label: 'Cat. Age',
          key: 'cat_age',
          sortable: false,
        },
        {
          label: 'Cat. Poids',
          key: 'cat_poids',
          sortable: false,
        },
        {
          label: 'Cat. Grade',
          key: 'cat_grade',
          sortable: false,
        },
        {
          label: 'Combats effectués',
          key: 'combat_eff',
          sortable: true,
        },
        {
          label: 'Place',
          key: 'place',
          sortable: true,
        },
        {
          label: 'Petite finale ?',
          key: 'petite_finale',
          sortable: true,
        },
        {
          label: 'Team ABFT ?',
          key: 'teamABFT',
          sortable: true,
        },
        {
          label: 'Afficher au ranking',
          key: 'afficherAuRanking',
          sortable: true,
        },
        {
          label: 'Points',
          key: 'pointsBonus',
          sortable: true,
        },

        {
          label: 'Actions',
          key: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getCompetition: 'getCompetition',
      getNiveauxCompetition: 'getNiveauxCompetition',
      getCategAge: 'getCategAge',
      getCategGrade: 'getCategGrade',
      getCategPoids: 'getCategPoids',
      getListeClub: 'getListeClub',
    }),
  },
  mounted: function () {
    var these = this
    this.resetParticipationForm()
    // this.getTableListingCompetition();
    this.$nextTick(function () {
      this.loadListeClub()
    })
  },
  created() {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm.getTableListingCompetition();
      // vm.loadStatutsCompetitions()
    })
  },
  watch: {
    'newParticipation.membre': function (membreSelectionne) {
      if (!membreSelectionne)
        return;
      this.sexeSelected = membreSelectionne.sexe;
      this.dejaParticipeAB = membreSelectionne.dejaParticipeAB;
      this.newParticipation.id_club = membreSelectionne.club.id

    },
    // 'sexeSelected': function (sexe_selected) {
    //     if (!sexe_selected)
    //         return;
    // },
    // 'newParticipation.id_age': function (id_age_selected) {
    //     if (!id_age_selected)
    //         return;
    // },
  },
  components: {
    vSelect,
    ListSelectClub,
  },
  methods: {
    ...mapActions({
      setListeClub: 'setListeClub',
    }),
    findClubById: function (id) {
      return this.getListeClub.find((item) => {
        return item.id == id
      })
    },
    loadListeClub: function () {
      return this.$http.get(this.getRoute('getAllClubs')).then((response) => {
        this.setListeClub(response.body)
        // this.isLoaded.club = true
      }, (response) => {
        // this.isLoaded.club = false
      });
    },
    isFormValid: function () {
      return this.newParticipation.membre != null
        && this.newParticipation.id_poids != null
        && this.newParticipation.id_age != null
        && this.newParticipation.id_club != null
        && this.newParticipation.id_grade != null
        && this.newParticipation.id_compet != null
        && this.newParticipation.id_compet != 0
        && this.newParticipation.id_poids != -1
        && this.newParticipation.id_grade != -1
        && this.newParticipation.id_age != -1
        && this.newParticipation.place != -1
    },
    resetParticipationForm: function () {
      this.sexeSelected = 1;
      if (this.newParticipation) {
        this.previousParticipation = {
          id_club: this.newParticipation.id_club,
          id_compet: this.newParticipation.id_compet,
          id_poids: this.newParticipation.id_poids,
          id_age: this.newParticipation.id_age,
          id_grade: this.newParticipation.id_grade,
          combat_eff: this.newParticipation.combat_eff,
          place: this.newParticipation.place,
          petite_finale: this.newParticipation.petite_finale,
          teamABFT: this.newParticipation.teamABFT,
          afficherAuRanking: this.newParticipation.afficherAuRanking,
        }
      }
      this.newParticipation = {
        membre: null,
        id_club: null,
        id_compet: this.getCompetition.id,
        id_poids: null,
        id_age: null,
        id_grade: null,
        combat_eff: 0,
        place: -1,
        petite_finale: false,
        teamABFT: false,
        afficherAuRanking: true,
      }
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      let these = this;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search}, {
        before(request) {
          if (these.previousRequest)
            these.previousRequest.abort();
          these.previousRequest = request;
        }
      }).then(resp => {
        loading(false)
        let idsAlreadyExists = "";
        this.ArrayMembersSearch = resp.data;
        this.getCompetition.participations.forEach((item) => {
          this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
            return item.membre.id == item2.id
          });
        })
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },
    constructForm: function () {
      return {
        id_membre: this.newParticipation.membre.id,
        id_club: this.newParticipation.id_club,
        id_compet: this.newParticipation.id_compet,
        id_poids: this.newParticipation.id_poids,
        id_age: this.newParticipation.id_age,
        id_grade: this.newParticipation.id_grade,
        combat_eff: this.newParticipation.combat_eff,
        place: this.newParticipation.place,
        petite_finale: this.newParticipation.petite_finale,
        teamABFT: this.newParticipation.teamABFT,
        afficherAuRanking: this.newParticipation.afficherAuRanking,
      }
    },
    constructFormParticipationsUpdate: function (participation) {
      return {
        id: participation.id,
        id_club: participation.id_club,
        id_compet: participation.id_compet,
        id_poids: participation.id_poids,
        id_age: participation.id_age,
        id_grade: participation.id_grade,
        combat_eff: participation.combat_eff,
        place: participation.place,
        petite_finale: participation.petite_finale,
        teamABFT: participation.teamABFT,
        afficherAuRanking: participation.afficherAuRanking,
      }
    },
    addParticipation: function () {
      this.disabledBtn = true;
      this.loading = true
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competition.storeInscription'), this.constructForm()).then(function (response) {
        self.$noty.success(this.newParticipation.membre.fullName + " a été ajouté à la competition")
        this.disabledBtn = false
        this.getCompetition.participations = response.body
        this.loading = false
        this.resetParticipationForm();
        this.ArrayMembersSearch = []
      }, (response) => {
        self.$noty.error("Erreur dans l'ajout du membre")
        this.disabledBtn = false
        this.loading = false
      });
    },
    validEditing: function (id) {
      this.loading = true
      let participationsToUpdate = _.find(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      });
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competition.updateInscription'),
        this.constructFormParticipationsUpdate(participationsToUpdate)).then(function (response) {
        self.$noty.success("La participation a bien été modifiée. " + response.body.pointsBonus + " points attribués.")
        this.disabledBtn = false
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
        this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
          return item.id == id;
        });

        let participationsToUpdateInTable = _.find(this.getCompetition.participations, function (item) {
          return item.id == id;
        });

        _.each(response.body, (item, index) => {
          participationsToUpdateInTable[index] = item;
        })
        this.loading = false
      }, (response) => {
        self.$noty.error("Erreur dans la modification de la participation")
        this.disabledBtn = false
        this.loading = false
      });
    },
    removeParticipations: function (id) {
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competition.deleteInscription'), {id: id}).then(function (response) {
        self.$noty.success("La participation a bien été supprimée")
        this.disabledBtn = false
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
        this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
          return item.id == id;
        });
        this.getCompetition.participations = _.reject(this.getCompetition.participations, function (item) {
          return item.id == id;
        });
      }, (response) => {
        self.$noty.error("Erreur dans la modification de la participation")
        this.disabledBtn = false
      });
    },
    flatten: function (obj) {
      var root = {};
      (function tree(obj, index) {
        var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          root[index + key + suffix] = obj[key];
          if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
          if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
      })(obj, "");
      return root;
    },
    sortCompareAdvanced: function (a, b, key) {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // Stringify the field data and use String.localeCompare
        return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
          numeric: true
        })
      }
    },
    getLabelFromKey: function (key) {
      switch (key) {
        case 'noire':
          return 'Dan';
          break;

        default:
          return key.charAt(0).toUpperCase() + key.slice(1);
          break;
      }
    },
    currentYear: function () {
      return moment().year();
    },
    console: function (event) {
      console.log(event);
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    get_place: function (numero, petite_finale) {
      switch (numero) {
        case 1:
          return "1<sup>er</sup>";
          break;
        default :
          return numero + "<sup>ème</sup>";
          break;
      }
    },
    findCategPoids: function (id) {
      return _.find(this.getCategPoids, function (item) {
        return item.id == id;
      })
    },
    findCategAge: function (id) {
      return _.find(this.getCategAge, function (item) {
        return item.id == id;
      })
    },
    findCategGrade: function (id) {
      return _.find(this.getCategGrade, function (item) {
        return item.id == id;
      })
    },
    filterCategAgeForThisCompetition: function () {
      return _.where(this.getCategAge, {
        new_categ: this.getCompetition.new_categ
      })
    },
    filterCategPoidsForThisCompetition: function (id_categ_age = null, sexe = null, olympique = null) {
      // console.log("coucou");

      olympique = olympique == null || !olympique ? this.getCompetition.olympique : olympique
      if (id_categ_age == null || sexe == null)
        return [];
      // console.log(id_categ_age+","+sexe+","+olympique);
      // console.log(
      //     _.where(this.getCategPoids, {
      //         id_categ_age: id_categ_age,
      //         sexe: sexe,
      //     })
      // );
      return _.where(this.getCategPoids, {
        olympique: olympique,
        id_categ_age: id_categ_age,
        sexe: sexe,
      })
    },
    cancelEditing: function (id) {
      this.arrayEdits = _.reject(this.arrayEdits, function (item) {
        return item == id;
      });
      this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      });

    },
    getObjectEditable: function (id) {
      return _.find(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      })
    },
    editItem: function (item) {
      this.arrayEdits.push(item.id);
      this.arrayParticipationsEdits.push(item)
    },
    isEditing: function (id) {
      return _.contains(this.arrayEdits, id)
    },
  }
  ,
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  }
  ,
}
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/Competition/InscriptionsResultats.vue